import { h } from "omi";

export function LightbulbGraphic() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="57" viewBox="0 0 48 57" fill="none">
      <path
        d="M28.8305 40.3789C24.9972 41.2777 21.2474 41.3277 17.5273 40.0493"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M17.5273 42.0381C20.9479 43.7433 24.7719 44.4573 28.4777 43.1489"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M29.5373 44.6826C26.1555 46.5378 20.7835 47.3309 17.2461 45.4458"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M18.6562 48.8521C21.8209 48.904 24.951 49.4221 27.9889 48.4036"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M26.9538 50.2479C24.6776 51.1907 22.2208 51.4177 19.7891 51.123"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M21.966 40.2911C22.7399 37.2747 22.1525 33.6892 20.7882 30.9308C19.9084 29.1538 17.8999 26.8248 18.3902 24.6647C18.5085 24.183 18.7854 23.7889 19.0623 23.3948C20.4564 21.4803 22.636 21.9643 23.9667 23.6913C24.7349 24.6521 25.1531 26.2502 24.21 27.2793C23.2716 28.3363 22.439 26.6664 22.3274 25.8503C22.0505 23.7376 24.5666 20.3307 26.6347 22.5052C29.3345 25.3475 25.8108 29.9099 25.0551 32.8655C24.4177 35.3395 24.9532 37.9544 25.1763 40.4222"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M12.9821 36.2856C11.8157 37.1804 10.7473 38.1444 9.73558 39.2714"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M10.0654 30.5231C8.07345 30.7842 6.19098 31.515 4.38821 32.3757"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M3.20453 24.3883C4.43774 23.8857 5.69497 23.5228 6.98485 23.1829"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M8.89881 15.883C7.23147 14.5322 5.4863 13.3966 3.67578 12.2148"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M11.3086 4.82959C12.5104 5.97406 13.5488 7.003 14.1622 8.56714"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M23.1936 8.18684C22.8025 6.58326 22.6724 4.99181 22.7331 3.33831"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M30.9984 9.55866C31.4204 8.5054 31.852 7.5081 32.3672 6.49619"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M36.6015 13.2267C38.5394 11.4774 38.2156 11.7643 40.2236 10.0892"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M39.6427 19.4273C40.6444 19.0802 41.7105 18.6068 42.7785 18.4781"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M39.5925 25.9523C40.8028 25.4821 41.6116 25.5136 42.7076 26.2144"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M38.1602 31.2412C38.7472 31.4843 39.2181 31.7189 39.7638 32.0557"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M33.6367 34.9336C34.4765 36.1415 35.0228 37.3142 35.5702 38.6596"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
      <path
        d="M22.8235 53.6274C22.6476 53.7733 21.8448 53.2796 21.4151 52.9512C18.5657 50.7404 16.5074 47.7863 16.6439 43.9017C16.7506 41.3477 17.91 39.0708 17.3793 36.4839C16.0747 30.229 9.39621 27.7934 12.485 19.5326C12.9157 18.3626 13.5886 17.2655 14.3741 16.3217C15.3027 15.2088 16.3016 14.1701 17.5206 13.4099C19.1568 12.4039 21.1439 11.7689 23.0695 11.7785C25.0787 11.7735 26.887 12.4375 28.6867 13.2181C30.146 13.8566 30.4527 13.803 31.714 14.7929C33.5406 16.2316 34.4471 17.8309 34.8644 20.0918C36.0594 26.7116 30.3326 30.6501 28.8214 36.561C28.0657 39.5164 29.6952 42.3149 29.5164 45.2849C29.3011 49.2121 25.7345 51.8515 22.6985 53.7356"
        stroke="#0C111D"
        stroke-width="1.2"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}
